import { LevelDesignerElementBase } from '../element-base';
import { PolygonElement } from '../polygon-element';
import { FormGroup, FormControl } from '@angular/forms';
import { PropertyMetadata } from '../../properties/property-types';
import { RegisterElement } from '../element-decorator';

@RegisterElement()
export class ParkingLevelElement extends PolygonElement {
    layerIndex: number = 0;
    public override TypeName: string = "ParkingLevel";
    public override ParentType: string | null = null;
    public override ParentFormGroupName: string | null = null;


    constructor(formGroup: FormGroup) {
        super(formGroup);
        
        // Ensure all required form controls exist
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
        if (!formGroup.contains('width')) {
            formGroup.addControl('width', new FormControl(10)); // Default width
        }
        if (!formGroup.contains('height')) {
            formGroup.addControl('height', new FormControl(10)); // Default height
        }
        if (!formGroup.contains('GeoLocationPoints')) {
            formGroup.addControl('GeoLocationPoints', new FormControl([-74.006, 40.7128])); // Default to NYC
        }
        if (!formGroup.contains('GeoRotation')) {
            formGroup.addControl('GeoRotation', new FormControl(0)); // Default rotation
        }
    }

    override clone(): ParkingLevelElement {
        return new ParkingLevelElement(this.formGroup);
    }

    override default(): ParkingLevelElement {
        this.points = [
            { x: 0, y: 0 },
            { x: 10, y: 0 },
            { x: 10, y: 10 },
            { x: 0, y: 10 }
        ];
        this.formGroup.patchValue({
            Name: '',
            width: 10,
            height: 10
        });
        return this;
    }

    override updateForm(): void {
       super.updateForm();
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Level Name',
                inputType: { type: 'text' },
                description: 'Identifier for this parking level',
                order: 1,
                category: 'General'
            },
            {
                displayName: 'Width',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 2,
                category: 'Dimensions',
                getValue: (element) => element.getWidth(),
                setValue: (element, value) => element.setWidth(value)
            },
            {
                displayName: 'Length',
                inputType: { 
                    type: 'dimension',
                    unit: 'meters'
                },
                order: 3,
                category: 'Dimensions',
                getValue: (element) => element.getHeight(),
                setValue: (element, value) => element.setHeight(value)
            },
            {
                displayName: 'latitude',
                inputType: { type: 'number', min: -90, max: 90 },
                description: 'Geographic latitude',
                order: 4,
                category: 'Map',
                getValue: (element) => {
                    const geoPoints = element.formGroup.get('GeoLocationPoints')?.value;
                    return Array.isArray(geoPoints) ? geoPoints[1] : 40.7128; // Default to NYC
                },
                setValue: (element, value) => {
                    var list = element.formGroup.get('GeoLocationPoints')?.value
                    list[1] = value;
                    element.formGroup.get('GeoLocationPoints')?.setValue(list);
                },
            },
            {
                displayName: 'longitude',
                inputType: { type: 'number', min: -180, max: 180 },
                description: 'Geographic longitude',
                order: 5,
                category: 'Map',
                getValue: (element) => {
                    const geoPoints = element.formGroup.get('GeoLocationPoints')?.value;
                    return Array.isArray(geoPoints) ? geoPoints[0] : 74.0060; // Default to NYC
                },
                setValue: (element, value) => {
                    var list = element.formGroup.get('GeoLocationPoints')?.value
                    list[0] = value;
                    element.formGroup.get('GeoLocationPoints')?.setValue(list);
                },
            },
            {
                formControlName: 'GeoRotation',
                displayName: 'Map Rotation',
                inputType: { type: 'number' },
                description: 'Rotation angle in degrees',
                order: 6,
                category: 'Map'
            }
        ];
    }
}
